export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7990.d052ebc1.jpg";